module.exports = __webpack_public_path__ + "static/headshot-small-1c8b27ec0c2ff7e7f18dce3c0fb236a5.jpg";